import { createComponent } from '@/common'
import { RouterView } from 'vue-router'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'

export const App = createComponent(null, () => {
  const { locale } = useI18n()

  const elementLocale = computed(() => {
    return locale.value === 'zh-cn' ? zhCn : en
  })

  const messageConfig = {
    offset: 80,
    grouping: true,
    plain: false,
  }

  return () => (
    <ElConfigProvider locale={elementLocale.value} message={messageConfig}>
      <RouterView />
    </ElConfigProvider>
  )
})
